export default "__VITE_ASSET__CqJSC4MC__"